import { useTranslation } from 'react-i18next';
import { Card, Table } from 'semantic-ui-react';
import CopyContentComponent from '../../../misc/CopyContent.component';
import dateToString from '../../../../services/misc/dateToString';
import { kycState } from '../../../../model/details/kycState';
import React from 'react';
import { signerState } from '../../../../model/details/signer';

type LeadKycWebIdComponentProps = {
    data: typeof kycState;
    signers: typeof signerState;
    copy?: boolean;
};

export default function LeadKycWebIdComponent(props: LeadKycWebIdComponentProps) {
    const { t } = useTranslation();

    function createValue(value: string): React.ReactElement {
        return props.copy ? <CopyContentComponent>{value}</CopyContentComponent> : <>{value || ''}</>;
    }

    return (
        <Card.Content>
            <Card.Header>{t('lead.detail.box.KYC.webId.headline')}</Card.Header>
            <Card.Description>
                <Table celled striped columns={2}>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell width={4}>{t('lead.detail.box.KYC.webId.status')}</Table.Cell>
                            <Table.Cell width={8} singleLine>
                                {createValue(props.data.status || 'n/a')}
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell width={4}>{t('lead.detail.box.KYC.webId.date')}</Table.Cell>
                            <Table.Cell singleLine>
                                {createValue((props.data.date && dateToString(props.data.date, 'dateLong')) || 'n/a')}
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            </Card.Description>
        </Card.Content>
    );
}
